import { ProgressSpinner } from "primereact/progressspinner";
import { useQuery } from "@tanstack/react-query";
import { getSubmissionStatusCounts } from "../../../../api/routes";
import { SubmissionStatusCountsResponse } from "../../../../client";
import { formatExactMoneyDollars } from "../../Money";
import styles from "./SubmissionAnalytics.module.css";

const STATUS_CARDS: {
  key: keyof SubmissionStatusCountsResponse;
  label: string;
  format?: "currency";
}[] = [
  { key: "pre_underwriting_review", label: "Pre-Underwriting Review" },
  { key: "cleared", label: "Cleared" },
  { key: "in_progress", label: "In Progress" },
  { key: "indicated", label: "Indicated" },
  { key: "quoted", label: "Quoted" },
  { key: "bound", label: "Bound" },
  { key: "quoted_premium", label: "Open Quoted Premium", format: "currency" },
  { key: "bound_premium", label: "Bound/Issued Premium", format: "currency" },
];

export const SubmissionAnalytics = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["submission-status-counts"],
    queryFn: getSubmissionStatusCounts,
  });

  if (isLoading) {
    return (
      <div className={styles.container}>
        <ProgressSpinner />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.title}>Submission Analytics</div>
      <div className={styles.grid}>
        {STATUS_CARDS.map(({ key, label, format }) => {
          const raw = data?.[key] ?? 0;
          const display =
            format === "currency"
              ? formatExactMoneyDollars(raw, {
                  withRounding: true,
                  withDollarSign: true,
                })
              : raw;
          return (
            <div key={key} className={styles.card}>
              <div
                className={styles.count}
                style={{ fontSize: format === "currency" ? "24px" : "36px" }}
              >
                {display}
              </div>
              <div className={styles.label}>{label}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
